import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router';
import { UncontrolledTooltip } from 'reactstrap';
import { Button, SpinnerArea } from '../../../../shared/components';
import { dateTimeFormat, tooltipPreventOverflowModifiers } from '../../../../shared/misc/utils';
import { OperActionPlan } from '../../../../services/types/ActionPlan';
import operActionPlanService from '../../../../services/operActionPlanService';
import Context from '../../../App/MainProvider/context';
import ActionPlanDeleteModal from './ActionPlanDeleteModal';
import Role from '../../../../types/role';
import NotificationContext from '../../../Notifications/NotificationContext';
import OperationContext from '../context';

interface Props {
  item: OperActionPlan;
  type?: 'current' | 'previous';
}

const ActionPlanVersion: React.FC<Props> = ({ item, type }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { service, inSuperUserMode, notify } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(Context);
  const canDelete = user.roleCode === Role.Admin || inSuperUserMode();

  const {
    operation: { number },
    reload: reloadOperation,
  } = useContext(OperationContext);

  const { reload: reloadNotifications } = useContext(NotificationContext);

  const [showDeleteActionPlanModal, setShowDeleteActionPlanModal] = useState(false);

  const download = (actionPlanId: number) => {
    service(() => operActionPlanService.downloadDocument(actionPlanId), {
      loader: setLoading,
    });
  };

  const deleteActionPlan = (idActionPlan: number) => {
    service(() => operActionPlanService.deleteAP(idActionPlan), {
      callback: () => {
        notify(t(`actionPlan`), t(`success-delete-actionPlan`), 'success');
        reloadOperation();
        reloadNotifications();
        navigate(`/operations/${number}/action-plan`);
      },
      loader: setLoading,
    });
  };
  return (
    <tr>
      <td>
        <Link
          key={`tv_link_to_${item.id}`}
          id={`tv_link_to_${item.id}`}
          to={`${location.pathname}/${item.id}`}
          state={{ fromLast: true }}
        >
          {t('actionPlanVersion', { version: item.version })}
        </Link>
      </td>
      <td>{item.createdBy}</td>
      <td>{dateTimeFormat(item.createdOn) || t('na')}</td>
      <td>{item.modifiedBy}</td>
      <td>{dateTimeFormat(item.modifiedOn) || t('na')}</td>
      <td>{t(item.language)}</td>
      <td>
        <SpinnerArea loading={loading}>
          <Button
            htmlId={`download_button_${item.id}`}
            icon="file-download"
            className="btn-tertiary no-padding"
            onClick={() => download(item.id)}
            text=""
          />
          <UncontrolledTooltip
            className="tooltip-impact"
            target={`download_button_${item.id}`}
            modifiers={tooltipPreventOverflowModifiers}
          >
            <p>Download</p>
          </UncontrolledTooltip>
          {canDelete && item.id && type === 'current' && (
            <>
              <Button
                htmlId="btnDelete"
                text=""
                onClick={() => setShowDeleteActionPlanModal(true)}
                className="btn-tertiary no-padding"
                icon="trash-alt"
              />
              <UncontrolledTooltip
                className="tooltip-impact"
                placement="bottom"
                target="btnDelete"
                modifiers={tooltipPreventOverflowModifiers}
              >
                {t('Delete')}
              </UncontrolledTooltip>
            </>
          )}
        </SpinnerArea>
        {canDelete && (
          <ActionPlanDeleteModal
            visible={showDeleteActionPlanModal}
            setVisible={setShowDeleteActionPlanModal}
            actionPlanId={item.id != null ? item.id : 0}
            callback={deleteActionPlan}
          />
        )}
      </td>
    </tr>
  );
};
export default ActionPlanVersion;
